import { useCallback } from 'react';
import { useLocation } from 'react-router';
import useNavigate from './router/useNavigate';

export default function useIsEditingInPlace(): [
  boolean,
  (isEditing: boolean) => void,
] {
  const location = useLocation();
  const navigate = useNavigate();
  const { edit } = location.state ?? { edit: false };

  const setIsEditing = useCallback(
    (isEditing: boolean) => {
      navigate(location, {
        replace: true,
        state: { ...location.state, edit: isEditing },
      });
    },
    [navigate, location],
  );

  return [Boolean(edit), setIsEditing];
}
